<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-04 14:35:19
 * @Description: 用户充电行为分析
 * @FilePath: \sheyang\src\module\overview\stationChargeModal\components\userChargingAns.vue
-->
<template>
  <div class="user-charging-ans">
    <pub-info-title :title="'用户充电行为分析'" :isModal="true" />
    <div ref="ansLine" class="power-line-chart"></div>
  </div>
</template>

<script>
import pubInfoTitle from '@/components/infoTitle/index.vue';
import * as Echarts from 'echarts';

export default {
  name: 'userChargingAns',
  components: {
    pubInfoTitle,
  },
  props: {
    chargingNumber: {
      type: Array,
      default: () => ([]),
    },
    chargingPercent: {
      type: Array,
      default: () => ([]),
    },
    xAxisData: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chargingNumber: {
      handler(val) {
        this.lineChartsInit();
      },
      deep: true,
    },
    chargingPercent: {
      handler() {
        this.lineChartsInit();
      },
      deep: true,
    },
    xAxisData: {
      handler() {
        this.lineChartsInit();
      },
      deep: true,
    },
  },
  mounted() {
    this.lineChartsInit();
    window.addEventListener('resize', () => {
      this.chart.resize();
    });
  },
  methods: {
    lineChartsInit() {
      this.chart = Echarts.init(this.$refs.ansLine);
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let str = `<div>${params[0].name}</div>`;
            params.forEach((item) => {
              str += `<div style='display:flex;'>
                      <div>${item.marker} </div>
                      <div style='width:80px'>${item.seriesName}</div>
                      <div style='font-weight:600;'>${item.value.toFixed(0)}</div>
                    </div>`;
            });
            return str;
          },
        },
        grid: {
          top: this.fitChartSize(30),
          left: '1%',
          right: '1%',
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: ['5%', '5%'],
          // data: ['0-3', '3-6', '6-9', '9-12', '12-15', '15-18', '18-21', '21-24'],
          data: [...this.xAxisData],
          axisTick: {
            show: false, // x 轴刻度是否显示
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: '#9A9A9A',
            fontSize: this.fitChartSize(12),
            margin: this.fitChartSize(14),
          },
        },
        yAxis: [
          {
            name: '次数',
            nameLocation: 'end',
            nameTextStyle: {
              color: '#fff',
              align: 'right',
              fontSize: this.fitChartSize(12),
              padding: [0, 2, 0, 0],
            },
            type: 'value',
            axisLabel: {
              color: '#C5C5C5',
              fontSize: this.fitChartSize(12),
              margin: this.fitChartSize(6),
            },
            splitLine: {
              show: true,
              lineStyle: {
                width: 1,
                color: 'rgba(43, 196, 255, 0.5)',
                type: 'dashed',
              },
            },
          },
          {
            name: '百分比',
            type: 'value',
            alignTicks: true,
            nameTextStyle: {
              color: '#fff',
              align: 'right',
              fontSize: this.fitChartSize(12),
              padding: [0, this.fitChartSize(-26), 0, 0],
            },
            axisLabel: {
              color: '#C5C5C5',
              fontSize: this.fitChartSize(12),
              margin: this.fitChartSize(6),
            },

            splitLine: {
              show: true,
              lineStyle: {
                width: 1,
                color: 'rgba(43, 196, 255, 0.5)',
                type: 'dashed',
              },
            },
          },
        ],
        series: [
          {
            name: '次数',
            type: 'line',
            smooth: true,
            symbol: 'none',
            itemStyle: {
              color: '#32BAFF',
              shadowColor: '#32BAFF',
              shadowBlur: 8,

            },
            lineStyle: {
              color: '#63FBE3',
            },
            data: [...this.chargingNumber],
          },
          {
            name: '百分比',
            type: 'bar',
            symbol: 'none',
            yAxisIndex: 1,
            barWidth: this.fitChartSize(10),
            itemStyle: {
              color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(101, 255, 230, 1)',
                },
                {
                  offset: 1,
                  color: 'rgba(101, 255, 230, 0)',
                },
              ]),
            },
            data: [...this.chargingPercent],

          },
        ],
      };
      this.chart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.user-charging-ans {
  ::v-deep .pub-info-title {
    margin-bottom: 22px;
  }
  .power-line-chart {
    width: 100%;
    height: 196px;
    margin-bottom: 18px;
  }
}
</style>
